import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import {FiX, FiInstagram, FiPlus, FiChevronDown } from "react-icons/fi";
import { FaFacebookF, FaLinkedin, FaLocationDot, FaRegClock, FaTwitter, FaYoutube } from "react-icons/fa6";
import { MdOutlineEmail, MdPhoneInTalk } from "react-icons/md";
import { TfiMenu } from "react-icons/tfi";
import logo_appnexts from "../assets/appnexts_1.png"
import { TiArrowSortedDown } from "react-icons/ti";
import { BsArrowUpRight } from "react-icons/bs";


export function NavBar() {
const [navOpen, setNavOpen] = useState(false);
const [servicesOpen, setServicesOpen] = useState(false);
const [activeDropdown, setActiveDropdown] = useState(null)
const dropdownTimeoutRef = useRef(null)
const [activeService, setActiveService] = useState("");
const location = useLocation();
const currentPath = location.pathname;

const isSolutionsActive =
  currentPath === "/our-services" || currentPath.startsWith("/services/");

       const services = [
    "Mobile App Development",
    "Website Development",
    "SEO Services",
    "Data Scraping",
    "Video Editing",
    "Graphics Design",
  ]

  const businessChallenges = [
    { name: "Digital Transformation", icon: "📊" },
    { name: "Security", icon: "🛡️" },
    { name: "Automation", icon: "⚙️" },
    { name: "Gaining Efficiency", icon: "📈" },
  ]

  const industryFocus = [
    "Industry Manufacturing",
    "Transportation Logistics",
    "Healthcare",
    "Banks & Insurance",
    "Consulting Providers",
    "Non Profit",
  ]

     const handleMouseEnter = (dropdown) => {
    if (dropdownTimeoutRef.current) clearTimeout(dropdownTimeoutRef.current)
    setActiveDropdown(dropdown)
  }

  const handleMouseLeave = () => {
    dropdownTimeoutRef.current = setTimeout(() => {
      setActiveDropdown(null)
    }, 150)
  }

  const handleDropdownMouseEnter = () => {
    if (dropdownTimeoutRef.current) clearTimeout(dropdownTimeoutRef.current)
  }

  const handleDropdownMouseLeave = () => {
    setActiveDropdown(null)
  }

  useEffect(() => {
    return () => {
      if (dropdownTimeoutRef.current) clearTimeout(dropdownTimeoutRef.current)
    }
  }, [])

  const toSlug = (str) => str.toLowerCase().replace(/\s+/g, "-")

  return (
<nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-75 bg-white shadow-sm" >
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo Section */}
          <Link to="/" className="flex items-center">
            <img  src={logo_appnexts } className="h-14 w-28"/>
          </Link>

          {/* Desktop Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
  <NavLink
  to="/"
  className={({ isActive }) =>
    `transition-colors ${
      isActive
        ? "font-semibold text-[#4898a5] border-b-2 border-[#4898a5]"
        : " text-gray-900 hover:text-[#4898a5]"
    }`
  }
>
  Home
</NavLink>


  <NavLink to="/about-us" className={({ isActive }) =>
    `transition-colors ${
      isActive
        ? "font-semibold text-[#4898a5] border-b-2 border-[#4898a5]"
        : " text-gray-900 hover:text-[#4898a5]"
    }`
  }>
    About
  </NavLink>

  <div className="relative group">
<Link
  to="/our-services"
  className={`flex items-center gap-1 transition-colors ${
    isSolutionsActive
      ? "text-[#4898a5] border-[#4898a5] font-semibold"
      : "text-gray-900 hover:text-[#4898a5]"
  }`}
  onMouseEnter={() => handleMouseEnter("solutions")}
  onMouseLeave={handleMouseLeave}
>
  Solutions
  <TiArrowSortedDown className="text-lg transition-transform group-hover:rotate-180" />
</Link>



              {activeDropdown === "solutions" && (
                <div
                  className="fixed left-0 right-0 top-20 w-full bg-white border-t border-gray-200 shadow-xl z-50 max-h-[80vh] overflow-y-auto"
                  onMouseEnter={handleDropdownMouseEnter}
                  onMouseLeave={handleDropdownMouseLeave}
                >
                  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12 grid lg:grid-cols-3 gap-8 lg:gap-12">
                    <div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-6">Services</h3>
                      <ul className="space-y-4">
                        {services.map((s, i) => (
  <li key={i}>
    <Link
      to={`/services/${toSlug(s)}`}
        onClick={() => {
    setActiveService(s);
    setActiveDropdown(null); // close the Solutions dropdown
  }}
      className={`block transition-colors text-lg ${
        activeService === s
          ? "border border-gray-300 rounded-lg px-4 py-3 bg-gray-50 font-medium text-gray-900"
          : "py-2 text-gray-600 hover:text-gray-900"
      }`}
    >
      {s}
    </Link>
  </li>
))}

                      </ul>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-6">Business Challenges</h3>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        {businessChallenges.map((c, i) => (
                          <Link key={i} to="/our-services" className="block p-6 border border-gray-200 rounded-xl hover:border-gray-300 hover:shadow-lg transition-all group">
                            <div className="text-3xl mb-3 group-hover:scale-110 transition-transform">{c.icon}</div>
                            <div className="text-base font-semibold text-gray-900">{c.name}</div>
                          </Link>
                        ))}
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center justify-between mb-6">
                        <h3 className="text-xl font-semibold text-gray-900">Industry Focus</h3>
                        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                          <div className="w-8 h-8 bg-blue-600 rounded-full"></div>
                        </div>
                      </div>
                      <ul className="space-y-4">
                        {industryFocus.map((i, idx) => (
                          <li key={idx}>
                            <span  className="block text-gray-600 hover:text-gray-900 transition-colors text-lg py-2">
                              {i}
                            </span>
                          </li>
                        ))}
                      </ul>
                      <Link to="/our-services" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold mt-6 transition-colors text-lg">
                        View all <BsArrowUpRight className="ml-2 h-5 w-5" />
                      </Link>
                    </div>
                  </div>
                </div>
              )}
            </div>


  <NavLink to="/portfolio-grid" className={({ isActive }) =>
    `transition-colors ${
      isActive
        ? "font-semibold text-[#4898a5] border-b-2 border-[#4898a5]"
        : " text-gray-900 hover:text-[#4898a5]"
    }`
  }>
    Portfolio
  </NavLink>
  <NavLink to="/blog" className={({ isActive }) =>
    `transition-colors ${
      isActive
        ? "font-semibold text-[#4898a5] border-b-2 border-[#4898a5]"
        : " text-gray-900 hover:text-[#4898a5]"
    }`
  }>
    Blog
  </NavLink>

  <NavLink to="/contact-us" className={({ isActive }) =>
    `transition-colors ${
      isActive
        ? "font-semibold text-[#4898a5] border-b-2 border-[#4898a5]"
        : " text-gray-900 hover:text-[#4898a5] "
    }`
  }>
    Contact
  </NavLink>
   

</div>



          {/* Actions Section */}
          <div className="flex items-center space-x-4 ">
            <button
              className="flex items-center space-x-2 px-4 py-2  rounded-full"
              aria-label="Login"
              onClick={() => setNavOpen(!navOpen)}
            >
              {navOpen ? <FiX className="w-6 h-6" /> : <TfiMenu  className="text-[#504e9a] w-6 h-6 transition-colors" />}
            </button>
          </div>

        {/* Side Navigation Menu */}
      {navOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-50"
          onClick={() => setNavOpen(false)}
        ></div>
      )}
    <div
  className={`fixed top-0 right-0 h-full p-6 bg-[#f3f7fb] shadow-lg shadow-[#4898a5] transform transition-transform duration-300 ${
    navOpen ? "translate-x-0" : "translate-x-full"
  } z-50 border-l border-[#4898a5] overflow-y-auto
    w-80 sm:w-80 md:w-96 lg:w-96`}
>

      <button
        className="absolute right-4 top-4 rounded-full bg-[#504e9a] p-2 text-white"
        onClick={() => setNavOpen(false)}
        aria-label="Close Menu"
      >
        <FiX className="h-6 w-6" />
      </button>
      <div >
        <div className="flex items-center gap-2">
          <span className="text-2xl font-bold">Appnexts</span>
        </div>

        <p className="mt-8 text-gray-600 px-2 py-5 hidden md:flex">
          AppNexts is a renowned international software development company.
           We specialize in providing custom software development solutions to businesses worldwide.
        </p>

                     
        <div className="md:hidden mt-10 space-y-6">
  <Link
    to="/"
    className="block text-gray-900 font-semibold p-1 border-b"
    onClick={() => setNavOpen(false)}
  >
    Home
  </Link>

  <Link
    to="/about-us"
    className="block text-gray-900 font-semibold p-1 border-b"
    onClick={() => setNavOpen(false)}
  >
    About
  </Link>

  {/* Services Dropdown */}
  <div>
    <button
      className="flex items-center justify-between w-full text-gray-900 font-semibold p-1 border-b"
      onClick={() => setServicesOpen(!servicesOpen)}
    >

     <Link to="/our-services"> Services</Link>
      <FiPlus
        className={`w-6 h-6 transition-transform ${servicesOpen ? "rotate-45" : ""}`}
      />
    </button>
    {servicesOpen && (
      <div className="ml-4 space-y-3">
  {services.map((s, i) => (
    <Link
      key={i}
      to={`/services/${toSlug(s)}`}
      className="block text-gray-900 font-semibold p-3 border-b"
      onClick={() => {
        setNavOpen(false);
        setServicesOpen(false);
        setActiveDropdown(null);
      }}
    >
      {s}
    </Link>
  ))}
</div>

    )}
  </div>


           
  <Link
    to="/portfolio-grid"
    className="block text-gray-900 font-semibold p-1 border-b"
    onClick={() => setNavOpen(false)}
  >
    Portfolio
  </Link>
  <Link
    to="/blog"
    className="block text-gray-900 font-semibold p-1 border-b"
    onClick={() => setNavOpen(false)}
  >
    Blog
  </Link>

  <Link
    to="/contact-us"
    className="block text-gray-900 font-semibold p-1 border-b"
    onClick={() => setNavOpen(false)}
  >
    Contact
  </Link>



</div>


        <div className="mt-3">
          <h2 className="text-2xl font-bold">Contact Info</h2>

          <div className="mt-6 space-y-6">
            <div className="flex items-start gap-3 text-gray-600">
              <FaLocationDot className="h-5 w-5 text-[#504e9a]" />
              <span className="font-semibold">Apartment 202, Dublin, Ohio, USA</span>
            </div>
            <div className="flex items-start gap-3 text-gray-600">
              <FaLocationDot className="h-5 w-5 text-[#504e9a]" />
              <span className="font-semibold">M10, Mezzanine Floor, Siddiq Trade Center,Gulberg Lahore</span>
            </div>
            

            <div className="flex items-start gap-3 text-gray-600">
              <MdOutlineEmail className="h-5 w-5 text-[#504e9a]" />
              <span className="font-semibold">info@appnexts.com</span>
            </div>

            <div className="flex items-start gap-3 text-gray-600">
              <FaRegClock className="h-5 w-5 text-[#504e9a]" />
              <span className="font-semibold">Mon-Fri, 10:00 AM - 07:00 PM</span>
            </div>

            <div className="flex items-start gap-3 text-gray-600">
              <MdPhoneInTalk className="h-5 w-5 text-[#504e9a]" />
              <span className="font-semibold"> (042) 35817087</span>
            </div>
          </div>
        </div>

        <Link
          to="/contact-us"
          className="mt-8 block rounded-md bg-[#504e9a] px-6 py-3 text-center font-semibold text-white transition-colors hover:bg-[#4898a5]"
        >
          Get A Quote
        </Link>

        <div className="mt-8 flex gap-4">
          <Link
            to="https://www.facebook.com/profile.php?id=61568551576819"
            className="rounded-full border p-2 text-gray-600 transition-colors hover:border-[#504e9a] hover:text-[#504e9a]"
          >
            <FaFacebookF className="h-5 w-5" />
          </Link>
          <Link
            to="https://www.youtube.com/@AppNexts"
            className="rounded-full border p-2 text-gray-600 transition-colors hover:border-[#504e9a] hover:text-[#504e9a]"
          >
            <FaYoutube className="h-5 w-5" />
          </Link>
          <Link
            to="https://www.linkedin.com/company/appnexts"
            className="rounded-full border p-2 text-gray-600 transition-colors hover:border-[#504e9a] hover:text-[#504e9a]"
          >
            <FaLinkedin className="h-5 w-5" />
          </Link>
        </div>
      </div>
    </div>

        </div>
      </div>
       
    </nav>
  );
}
